import styled from "@emotion/styled";

export const StyledDiv = styled.div`
  inline-size: fit-content;

  border-radius: 2px;

  background-color: #ffffff;

  box-shadow: 0 0 1px 2px rgb(0 0 0 / 0.02), 2px 3px 10px 0 rgb(0 0 0 / 0.05);
`;
